module.exports = __webpack_public_path__ + "fa2cf40ae5d860d8167e73a8ceecf6aa.png";